import React, { useEffect, useState } from "react";
import { LIMIT } from "../constent/ConstentVariable";
import { fetchMutation, fetchQuery } from "../../../actions";
import {
   CREATE_NOTES,
   DELETE_CREATE_NOTES,
   GET_DICTATION_SIGNED_URL,
   GET_NOTES_DATA,
   GET_NOTES_TEMPLATES_DATA,
} from "../actions/notesAct";
import { withRouter } from "react-router";
import { ShowAlert } from "../../../common/alert";
import TemplateNDicationComp from "../component/TemplateNDicationComp";
import PollComponent from "./pollComponent";
import { errorToDisplay } from "../../../helper/CommonFuncs";
import { socketActions, socketSubActions } from "../../../helper/Websocket";
// let stopRefetching = 0;

const TemplateNDicationCont = (props) => {
   const {
      mediaId,
      editComponent,
      setEditComponent,
      setIsStartRecording,
      updateNotes = () => {},
      GetNotes = () => {},
      setShowComponent,
      statusPending,
      setShowTemplateSelection,
      showTemplateSelection,
      history,
      notesList,
      selectedNoteId,
      setNoteId,
      setShowDeletePopup,
      isVimProvider = false,
   } = props;
   const noteId = selectedNoteId;
   const [SummaryData, setSummaryData] = useState([]);
   const [signedUrl, setSignUrl] = useState(null);
   const [tempId, setTempId] = useState("");
   const [loading, setLoading] = useState(false);
   const [dictationLoading, setDictationLoading] = useState(false);
   const [activeTab, setActiveTab] = useState("tab1");
   const [startPolling, setStartPolling] = useState(null);
   const [templateData, setTemplateData] = useState({
      list: [],
      loading: true,
      notes: { limit: LIMIT, offset: 0, enabledTemplate: true },
   });

   const updateNotesTemp = (generateNote) => {
      let notesObj = {
         createNotes: generateNote,
      };
      fetchMutation(CREATE_NOTES, notesObj, (res) => {
         getGeneratedNotes(res?.data?.createNotes?.notes?.id);
      });
   };
   const getGeneratedNotes = (noteIdNew, reloadComponent = true) => {
      if (reloadComponent) {
         setLoading(true);
      }
      setActiveTab("tab1");
      let obj = {};
      let notes = {
         limit: LIMIT,
         offset: 0,
         id: noteIdNew,
      };
      obj.notes = notes;
      fetchQuery(
         GET_NOTES_DATA,
         obj,
         (res) => {
            const contentData = res?.data?.getNotes?.notes.length > 0 ? res?.data?.getNotes?.notes[0] : [];
            const id = contentData ? contentData?.templateId : null;
            if (contentData?.mediaId) {
               getDiction(contentData);
            }
            if (contentData?.status === "pending" || contentData?.status === "draft") {
               setStartPolling(noteIdNew);
            }
            setSummaryData(contentData);
            setTempId(id);
            setLoading(false);

            getDiction(contentData);
            //
         },
         (err) => {
            setLoading(false);
         }
      );
   };
   const getDiction = (refetchedData = []) => {
      const mediaIdFromApi = refetchedData?.mediaId || "";
      const mediaToPass = mediaIdFromApi ? mediaIdFromApi : mediaId;
      setDictationLoading(true);
      let obj = { thumbnail: true, includeDiarization: true, content: { id: mediaToPass } };
      fetchQuery(
         GET_DICTATION_SIGNED_URL,
         obj,
         (res) => {
            let contentData = {
               dictation: res?.data?.getSignedURL?.Diarization,
               url: res?.data?.getSignedURL?.url,
            };
            setSignUrl(contentData);
            setDictationLoading(false);
         },
         (err) => {
            setDictationLoading(false);
         }
      );
   };
   const deleteNotes = (generateNote) => {
      let notesObj = {
         createNotes: generateNote,
      };

      fetchMutation(
         DELETE_CREATE_NOTES,
         notesObj,
         (res) => {
            setNoteId();
            const message = res?.data?.createNotes?.status?.message;
            ShowAlert(message);
         },
         (error) => {
            ShowAlert(errorToDisplay(error), "error");
         }
      );
   };
   useEffect(() => {
      getGeneratedNotes(noteId);
   }, [noteId]);
   const getNotesGenerate = () => {
      // let obj = {
      //    subAction: socketSubActions?.getTemplateList,
      //    action: socketActions?.onboarding,
      // };
      // window.socket.send(obj, (data) => {
      //    const notesData = data?.data || [];
      //    const Results = notesData;
      //    setTemplateData({
      //       ...templateData,
      //       list: Results,
      //       loading: false,
      //       offset: null,
      //    });
      // });

      let obj = {};
      let notesTemplate = {
         limit: 50,
         offset: 0,
         enabledTemplate: true,
      };
      obj.notesTemplate = notesTemplate;
      fetchQuery(
         GET_NOTES_TEMPLATES_DATA,
         obj,
         (res) => {
            const notesData = res?.data?.getNotesTemplate?.template || [];
            const Results = notesData;
            setTemplateData({
               ...templateData,
               list: Results,
               loading: false,
               offset: null,
            });
         },
         (err) => {}
      );
   };
   useEffect(() => {
      getNotesGenerate(noteId);
   }, []);

   return (
      <>
         {startPolling && (
            <PollComponent
               noteId={startPolling}
               setSummaryData={(data) => {
                  setSummaryData(data);
                  getDiction(data);
               }}
               setStartPolling={setStartPolling}
            />
         )}
         <TemplateNDicationComp
            isVimProvider={isVimProvider}
            setShowDeletePopup={setShowDeletePopup}
            setNoteId={setNoteId}
            setShowTemplateSelection={setShowTemplateSelection}
            showTemplateSelection={showTemplateSelection}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            SummaryData={SummaryData}
            tempId={tempId}
            noteId={noteId}
            signedUrl={signedUrl}
            GetNotes={GetNotes}
            updateNotes={updateNotes}
            deleteNotes={deleteNotes}
            getGeneratedNotes={getGeneratedNotes}
            dictationLoading={dictationLoading}
            templateData={templateData}
            editComponent={editComponent}
            setEditComponent={setEditComponent}
            setIsStartRecording={setIsStartRecording}
            updateNotesTemp={updateNotesTemp}
            loading={loading}
            setShowComponent={setShowComponent}
            statusPending={statusPending}
         />
      </>
   );
};

export default withRouter(TemplateNDicationCont);
